import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.limitElement = document.querySelector(".stop-destinations")
    this.footerElement = document.querySelector("footer")

    this.handleScroll = this.handleScroll.bind(this)

    window.addEventListener("scroll", this.handleScroll, { passive: true })
    window.addEventListener("resize", this.handleScroll)

    if (this.footerElement) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.buttonTarget.classList.add("opacity-0", "pointer-events-none")
            } else {
              this.buttonTarget.classList.remove("opacity-0", "pointer-events-none")
            }
          })
        },
        { threshold: 0.1 }
      )

      this.footerObserver.observe(this.footerElement)
    }

    this.handleScroll()
  }

  handleScroll() {
    if (!this.hasButtonTarget || !this.limitElement) return

    const limitTop = this.limitElement.offsetTop
    const buttonHeight = this.buttonTarget.offsetHeight
    const scrollBottom = window.scrollY + window.innerHeight

    const stopOffset = 30
    const stopPoint = limitTop - stopOffset

    if (scrollBottom >= stopPoint + buttonHeight) {
      this.buttonTarget.classList.remove("fixed", "bottom-[20px]")
      this.buttonTarget.classList.add("absolute")
      this.buttonTarget.style.top = `${limitTop - buttonHeight - stopOffset}px`
      this.buttonTarget.style.bottom = ""
    } else {
      this.buttonTarget.classList.remove("absolute")
      this.buttonTarget.classList.add("fixed", "bottom-[20px]")
      this.buttonTarget.style.top = ""
    }
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("resize", this.handleScroll)

    if (this.footerObserver) this.footerObserver.disconnect()
  }
}